import React from 'react';
import { Hero } from '../components/Hero';
import { WhatWeDo } from '../components/WhatWeDo';
import { HowItWorks } from '../components/HowItWorks';
import { Services } from '../components/Services';
import { WhoWeServe } from '../components/WhoWeServe';
import { Pricing } from '../components/Pricing';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
export function HomePage() {
  return <>
      <Hero data-id="element-366" />
      <WhatWeDo data-id="element-367" />
      <HowItWorks data-id="element-368" />
      <Services data-id="element-369" />
      <WhoWeServe data-id="element-370" />
      <Pricing data-id="element-371" />
      <Testimonials data-id="element-372" />
      <FAQ data-id="element-373" />
    </>;
}